(function () {
  'use strict';

  /* @ngdoc object
   * @name sageFlightDataReport
   * @description
   *
   */
  angular
    .module('sageFlightDataReport', [
      'ui.router'
    ]);
}());
